import { SANDBOX_PRESET_TAG as T } from '../presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from '../../sandboxPresetTypes'

/**
 * Indeterminate loader without SVG: `conic-gradient` paints a wedge; `mask` punches a hole so you see a ring.
 * `-webkit-mask` duplicates `mask` for WebKit. Animation is a simple infinite rotate on the element.
 */
const shell = SANDBOX_PRESET_BODY_CSS

const preset: SandboxComponentPreset = {
  id: 'spinner-ring',
  category: 'loading',
  title: 'Spinner (rotating ring)',
  description: 'Indeterminate ring: conic-gradient plus mask for the gap.',
  tags: [T.loading, T.animation, T.css],
  html: `<h2>Ring spinner</h2>

<!-- role=status + aria-label: announces as in-progress without exposing percent -->
<div class="spinner" role="status" aria-label="Loading"></div>
<p class="note">Pure CSS.</p>`,
  css: `${shell}

h2 {
  color: var(--nogrok-preview-primary);
  margin: 0 0 1rem;
}

.spinner {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: conic-gradient(from 0deg, var(--nogrok-preview-primary), transparent 55%, transparent);
  animation: sp1 0.85s linear infinite;
  /* Hollow center: opaque ring mask (see transparent band thickness vs element size) */
  mask: radial-gradient(farthest-side, transparent calc(100% - 5px), #fff 0);
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 5px), #fff 0);
}

@keyframes sp1 {
  to {
    transform: rotate(360deg);
  }
}

.note {
  font-size: 0.8rem;
  opacity: 0.75;
  margin-top: 1rem;
}`,
  js: '',
}

export default preset
